// extracted by mini-css-extract-plugin
module.exports = {"entry":"ServerEntry_entry__2HVqg","name":"ServerEntry_name__2nJNq"};